// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/AkayaTelivigala-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/AkayaTelivigala-Regular.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-pri: #162938;
  --color-sec: #213d53;
  /* --color-tri: rgb(53, 53, 54); */
  --color-tri: #1b3b5357;
  --color-qua: #b1c5d3;
  --color-hit: rgb(133, 11, 11);
  --color-valid: rgb(123, 165, 123);
  --color-invalid: rgb(204, 154, 154);
  --filter-color-qua: brightness(0) saturate(100%) invert(80%) sepia(16%)
    saturate(287%) hue-rotate(162deg) brightness(97%) contrast(86%);
  --size-pri: clamp(1rem, 0.8rem + 0.4vw, 1.2rem);
  --radius-pri: 10px;
  font-family:
    "Akaya Telivigala",
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
  letter-spacing: 0.1em;
  line-height: 1.3em;
}

@font-face {
  font-family: "Akaya";
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

* {
  color: var(--color-qua);
}

body {
  background: linear-gradient(100deg, var(--color-pri), var(--color-sec));
  height: 100vh;
  display: flex;
  align-content: center;
}

button {
  width: 70%;
  min-width: 0;
  padding: 0.3em 0.3em;
  border-radius: var(--radius-pri);
  color: var(--color-pri);
  background-color: var(--color-qua);
  border: none;
}

button:not(.inactive):hover {
  background-color: var(--color-pri);
  color: var(--color-qua);
  outline: 0.1em solid var(--color-qua);
  cursor: pointer;
}

#restart {
  position: absolute;
  --spacing: min(1vh, 1vw);
  width: max(4vh, 4vw);
  aspect-ratio: 1 / 1;
  border-radius: 100%;
  position: absolute;
  top: var(--spacing);
  left: var(--spacing);
  font-weight: 500;
  font-size: 0.8rem;

  :hover {
    cursor: pointer;
  }
}

#github {
  --spacing: min(1vh, 1vw);
  width: max(3vh, 3vw);
  position: absolute;
  filter: var(--filter-color-qua);
  top: var(--spacing);
  right: var(--spacing);

  :hover {
    cursor: pointer;
  }
}

.container {
  position: relative;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(3, auto);
  place-items: center;
  place-content: center;
  width: 80%;
  gap: calc(2 * var(--size-pri));
}

.container > * {
  background-color: var(--color-pri);
  box-shadow:
    0.1em 0.1em 0.3em 0.2em var(--color-tri),
    -0.1em -0.1em 0.3em 0.2em var(--color-tri);
  border-radius: var(--radius-pri);
  display: flex;
  padding: var(--size-pri);
  width: 100%;
  height: 100%;
  place-content: center;
  place-items: center;
}

.header {
  grid-column: span 2;
  font-size: calc(2 * var(--size-pri));
  font-weight: 900;
  text-wrap: balance;
  text-align: center;
  line-height: 1em;
}

.left-panel {
  flex-direction: column;
  gap: 2rem;
  text-align: center;
}

.player-name {
  margin-top: var(--size-pri);
  font-size: calc(1.5 * var(--size-pri));
  font-weight: 700;
  width: 100%;
  line-height: 1em;
}

.input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  place-items: center;

  input {
    border-radius: var(--radius-pri);
    background-color: var(--color-qua);
    border: none;
    color: var(--color-pri);
    font-weight: 900;
    padding: 0.1em 0.5em;
    text-align: center;
    max-width: 80%;
  }

  input:focus {
    box-shadow:
      0.3em 0.3em 0.3em 0.1em var(--color-sec),
      -0.3em -0.3em 0.3em 0.1em var(--color-sec),
      -0.3em 0.3em 0.3em 0.1em var(--color-sec),
      0.3em -0.3em 0.3em 0.1em var(--color-sec);
    outline: none;
  }
}

.fleet {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;

  .ship {
    display: flex;
    grid-auto-flow: column;
    gap: 0.1rem;
    background-color: transparent;
    transition: transform 0.5s;

    > * {
      height: 2rem;
      aspect-ratio: 1 / 1;
      background-color: var(--color-qua);
      border-radius: var(--radius-pri);
      outline: 0.2em ridge var(--color-pri);
    }
  }

  .ship.vertical {
    transform: rotate(90deg);
    /* flex-direction: column; */
  }

  .ship:hover {
    cursor: move;
  }

  .placed {
    > * {
      background-color: transparent;
      border: 0.1em solid var(--color-qua);
      outline: none;
    }
  }

  .placed:hover {
    cursor: none;
  }
}

.buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1rem;
  row-gap: 3rem;
  place-items: center;
  width: 80%;
  max-width: 40ch;

  #start {
    grid-column: 1 / 3;
    width: 60%;
    margin-bottom: var(--size-pri);
  }

  #start.inactive {
    cursor: not-allowed;
    filter: grayscale(0.5) blur(1px);
  }

  #random {
    justify-self: end;
  }

  #clear {
    justify-self: start;
  }
}

.right-panel {
  flex-direction: column;
  text-align: center;
  gap: calc(2 * var(--size-pri));
}

.grid {
  aspect-ratio: 1 /1;
  margin: auto;
  display: grid;
  grid-template-rows: repeat(10, 1fr);
  grid-template-columns: repeat(10, 1fr);
  gap: 0.2rem;
  perspective: 400px;

  .cell {
    width: clamp(1rem, 1rem + max(1.5vh, 1.5vw), 5rem);
    aspect-ratio: 1 /1;
    position: relative;
    border-radius: 0.3em;
    transition: transform 0.6s ease-in-out;
    transform-style: preserve-3d;
  }

  .cell .front,
  .cell .back {
    position: absolute;
    inset: 0;
    border-radius: 8px;
    backface-visibility: hidden;
  }

  .cell .front {
    background: var(--color-qua);
  }

  .cell .back {
    transform: rotateY(180deg);
  }

  .cell.hit,
  .cell.miss,
  .cell.sunk {
    transform: rotateY(180deg);
  }

  .cell.hit .back {
    background: var(--color-hit);
  }

  .cell.miss .back {
    background: var(--color-sec);
  }

  .cell.sunk .back {
    background: var(--color-sec);
    outline: 0.3em ridge var(--color-hit);
  }

  .cell.sunk .front {
    outline: 0.3em ridge var(--color-hit);
  }

  .cell.valid .front {
    background-color: var(--color-valid);
  }

  .cell.invalid .front {
    background-color: var(--color-invalid);
  }

  .cell.drop .front {
    outline: 0.3em solid var(--color-valid);
    background-color: var(--color-sec);
  }
}

.grid:not(.battle) .cell:not(.drop) .front:hover {
  background-color: color-mix(in srgb, var(--color-qua), black 10%);
  cursor: pointer;
}

.battle {
  opacity: 0.5;
  cursor: none;
  animation: slide-in 1s;

  .cell.drop {
    outline: 0.3em solid var(--color-valid);
  }
}

dialog {
  padding: calc(2 * var(--size-pri));
  border-radius: var(--radius-pri);
  background-color: var(--color-pri);
  text-align: center;

  button {
    margin-top: calc(2 * var(--size-pri));
    width: 50%;
  }

  span {
    font-size: 1.5em;
    font-weight: 700;
    margin-left: 0.5em;
    margin-right: 0.5em;
  }
}

dialog::backdrop {
  backdrop-filter: blur(5px);
}

.info-bar {
  position: relative;
  grid-column: span 2;
  overflow: hidden;
  text-align: center;
  padding: calc(1.5 * var(--size-pri));
  z-index: -1;
}

.sonar-emitter,
.sonar-wave {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  width: 0;
  height: 0;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.sonar-wave1 {
  animation: sonar 4s linear infinite;
}

.sonar-wave2 {
  animation: sonar 4s linear 2.5s infinite;
}

.info-text {
  z-index: 1;
  font-size: calc(1.5 * var(--size-pri));
  font-weight: 500;
}

@keyframes push-in {
  from {
    transform: translateY(150%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-in {
  from {
    transform: translateX(40vw);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes sonar {
  0% {
    width: 0;
    height: 0;
    opacity: 0.6;
  }
  50% {
    width: 80vw;
    height: 500px;
    opacity: 0.1;
  }
  100% {
    width: 80vw;
    height: 500px;
    opacity: 0;
  }
}

@media (max-width: 800px) {
  .container {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
    grid-auto-flow: column;

    > * {
      grid-column: span 2;
    }

    > *:first-child {
      margin-top: calc(2 * var(--size-pri));
    }

    > *:last-child {
      margin-bottom: calc(2 * var(--size-pri));
    }
  }

  .battle {
    animation: push-in 1s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/main-style.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,iCAAiC;EACjC,mCAAmC;EACnC;mEACiE;EACjE,+CAA+C;EAC/C,kBAAkB;EAClB;;;;;;;;;;;;cAYY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB;;0DAE6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uEAAuE;EACvE,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;;EAEjB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;;EAErB;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC;;8CAE4C;EAC5C,gCAAgC;EAChC,aAAa;EACb,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;;EAEnB;IACE,gCAAgC;IAChC,kCAAkC;IAClC,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE;;;;+CAI2C;IAC3C,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;;EAEnB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,6BAA6B;IAC7B,0BAA0B;;IAE1B;MACE,YAAY;MACZ,mBAAmB;MACnB,kCAAkC;MAClC,gCAAgC;MAChC,qCAAqC;IACvC;EACF;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE;MACE,6BAA6B;MAC7B,oCAAoC;MACpC,aAAa;IACf;EACF;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;;EAEf;IACE,kBAAkB;IAClB,UAAU;IACV,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,sCAAsC;EACtC,WAAW;EACX,kBAAkB;;EAElB;IACE,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sCAAsC;IACtC,4BAA4B;EAC9B;;EAEA;;IAEE,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;IAC5B,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;IACvC,kCAAkC;EACpC;AACF;;AAEA;EACE,iEAAiE;EACjE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;;EAEtB;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;;EAElB;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,SAAS;EACT,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,YAAY;EACd;EACA;IACE,WAAW;IACX,aAAa;IACb,YAAY;EACd;EACA;IACE,WAAW;IACX,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,mCAAmC;IACnC,sBAAsB;;IAEtB;MACE,mBAAmB;IACrB;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,wCAAwC;IAC1C;EACF;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[":root {\n  --color-pri: #162938;\n  --color-sec: #213d53;\n  /* --color-tri: rgb(53, 53, 54); */\n  --color-tri: #1b3b5357;\n  --color-qua: #b1c5d3;\n  --color-hit: rgb(133, 11, 11);\n  --color-valid: rgb(123, 165, 123);\n  --color-invalid: rgb(204, 154, 154);\n  --filter-color-qua: brightness(0) saturate(100%) invert(80%) sepia(16%)\n    saturate(287%) hue-rotate(162deg) brightness(97%) contrast(86%);\n  --size-pri: clamp(1rem, 0.8rem + 0.4vw, 1.2rem);\n  --radius-pri: 10px;\n  font-family:\n    \"Akaya Telivigala\",\n    system-ui,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    \"Open Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n  letter-spacing: 0.1em;\n  line-height: 1.3em;\n}\n\n@font-face {\n  font-family: \"Akaya\";\n  src:\n    url(\"../fonts/AkayaTelivigala-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/AkayaTelivigala-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n* {\n  color: var(--color-qua);\n}\n\nbody {\n  background: linear-gradient(100deg, var(--color-pri), var(--color-sec));\n  height: 100vh;\n  display: flex;\n  align-content: center;\n}\n\nbutton {\n  width: 70%;\n  min-width: 0;\n  padding: 0.3em 0.3em;\n  border-radius: var(--radius-pri);\n  color: var(--color-pri);\n  background-color: var(--color-qua);\n  border: none;\n}\n\nbutton:not(.inactive):hover {\n  background-color: var(--color-pri);\n  color: var(--color-qua);\n  outline: 0.1em solid var(--color-qua);\n  cursor: pointer;\n}\n\n#restart {\n  position: absolute;\n  --spacing: min(1vh, 1vw);\n  width: max(4vh, 4vw);\n  aspect-ratio: 1 / 1;\n  border-radius: 100%;\n  position: absolute;\n  top: var(--spacing);\n  left: var(--spacing);\n  font-weight: 500;\n  font-size: 0.8rem;\n\n  :hover {\n    cursor: pointer;\n  }\n}\n\n#github {\n  --spacing: min(1vh, 1vw);\n  width: max(3vh, 3vw);\n  position: absolute;\n  filter: var(--filter-color-qua);\n  top: var(--spacing);\n  right: var(--spacing);\n\n  :hover {\n    cursor: pointer;\n  }\n}\n\n.container {\n  position: relative;\n  margin: auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: repeat(3, auto);\n  place-items: center;\n  place-content: center;\n  width: 80%;\n  gap: calc(2 * var(--size-pri));\n}\n\n.container > * {\n  background-color: var(--color-pri);\n  box-shadow:\n    0.1em 0.1em 0.3em 0.2em var(--color-tri),\n    -0.1em -0.1em 0.3em 0.2em var(--color-tri);\n  border-radius: var(--radius-pri);\n  display: flex;\n  padding: var(--size-pri);\n  width: 100%;\n  height: 100%;\n  place-content: center;\n  place-items: center;\n}\n\n.header {\n  grid-column: span 2;\n  font-size: calc(2 * var(--size-pri));\n  font-weight: 900;\n  text-wrap: balance;\n  text-align: center;\n  line-height: 1em;\n}\n\n.left-panel {\n  flex-direction: column;\n  gap: 2rem;\n  text-align: center;\n}\n\n.player-name {\n  margin-top: var(--size-pri);\n  font-size: calc(1.5 * var(--size-pri));\n  font-weight: 700;\n  width: 100%;\n  line-height: 1em;\n}\n\n.input {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  place-items: center;\n\n  input {\n    border-radius: var(--radius-pri);\n    background-color: var(--color-qua);\n    border: none;\n    color: var(--color-pri);\n    font-weight: 900;\n    padding: 0.1em 0.5em;\n    text-align: center;\n    max-width: 80%;\n  }\n\n  input:focus {\n    box-shadow:\n      0.3em 0.3em 0.3em 0.1em var(--color-sec),\n      -0.3em -0.3em 0.3em 0.1em var(--color-sec),\n      -0.3em 0.3em 0.3em 0.1em var(--color-sec),\n      0.3em -0.3em 0.3em 0.1em var(--color-sec);\n    outline: none;\n  }\n}\n\n.fleet {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n\n  .ship {\n    display: flex;\n    grid-auto-flow: column;\n    gap: 0.1rem;\n    background-color: transparent;\n    transition: transform 0.5s;\n\n    > * {\n      height: 2rem;\n      aspect-ratio: 1 / 1;\n      background-color: var(--color-qua);\n      border-radius: var(--radius-pri);\n      outline: 0.2em ridge var(--color-pri);\n    }\n  }\n\n  .ship.vertical {\n    transform: rotate(90deg);\n    /* flex-direction: column; */\n  }\n\n  .ship:hover {\n    cursor: move;\n  }\n\n  .placed {\n    > * {\n      background-color: transparent;\n      border: 0.1em solid var(--color-qua);\n      outline: none;\n    }\n  }\n\n  .placed:hover {\n    cursor: none;\n  }\n}\n\n.buttons {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: 1rem;\n  row-gap: 3rem;\n  place-items: center;\n  width: 80%;\n  max-width: 40ch;\n\n  #start {\n    grid-column: 1 / 3;\n    width: 60%;\n    margin-bottom: var(--size-pri);\n  }\n\n  #start.inactive {\n    cursor: not-allowed;\n    filter: grayscale(0.5) blur(1px);\n  }\n\n  #random {\n    justify-self: end;\n  }\n\n  #clear {\n    justify-self: start;\n  }\n}\n\n.right-panel {\n  flex-direction: column;\n  text-align: center;\n  gap: calc(2 * var(--size-pri));\n}\n\n.grid {\n  aspect-ratio: 1 /1;\n  margin: auto;\n  display: grid;\n  grid-template-rows: repeat(10, 1fr);\n  grid-template-columns: repeat(10, 1fr);\n  gap: 0.2rem;\n  perspective: 400px;\n\n  .cell {\n    width: clamp(1rem, 1rem + max(1.5vh, 1.5vw), 5rem);\n    aspect-ratio: 1 /1;\n    position: relative;\n    border-radius: 0.3em;\n    transition: transform 0.6s ease-in-out;\n    transform-style: preserve-3d;\n  }\n\n  .cell .front,\n  .cell .back {\n    position: absolute;\n    inset: 0;\n    border-radius: 8px;\n    backface-visibility: hidden;\n  }\n\n  .cell .front {\n    background: var(--color-qua);\n  }\n\n  .cell .back {\n    transform: rotateY(180deg);\n  }\n\n  .cell.hit,\n  .cell.miss,\n  .cell.sunk {\n    transform: rotateY(180deg);\n  }\n\n  .cell.hit .back {\n    background: var(--color-hit);\n  }\n\n  .cell.miss .back {\n    background: var(--color-sec);\n  }\n\n  .cell.sunk .back {\n    background: var(--color-sec);\n    outline: 0.3em ridge var(--color-hit);\n  }\n\n  .cell.sunk .front {\n    outline: 0.3em ridge var(--color-hit);\n  }\n\n  .cell.valid .front {\n    background-color: var(--color-valid);\n  }\n\n  .cell.invalid .front {\n    background-color: var(--color-invalid);\n  }\n\n  .cell.drop .front {\n    outline: 0.3em solid var(--color-valid);\n    background-color: var(--color-sec);\n  }\n}\n\n.grid:not(.battle) .cell:not(.drop) .front:hover {\n  background-color: color-mix(in srgb, var(--color-qua), black 10%);\n  cursor: pointer;\n}\n\n.battle {\n  opacity: 0.5;\n  cursor: none;\n  animation: slide-in 1s;\n\n  .cell.drop {\n    outline: 0.3em solid var(--color-valid);\n  }\n}\n\ndialog {\n  padding: calc(2 * var(--size-pri));\n  border-radius: var(--radius-pri);\n  background-color: var(--color-pri);\n  text-align: center;\n\n  button {\n    margin-top: calc(2 * var(--size-pri));\n    width: 50%;\n  }\n\n  span {\n    font-size: 1.5em;\n    font-weight: 700;\n    margin-left: 0.5em;\n    margin-right: 0.5em;\n  }\n}\n\ndialog::backdrop {\n  backdrop-filter: blur(5px);\n}\n\n.info-bar {\n  position: relative;\n  grid-column: span 2;\n  overflow: hidden;\n  text-align: center;\n  padding: calc(1.5 * var(--size-pri));\n  z-index: -1;\n}\n\n.sonar-emitter,\n.sonar-wave {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  width: 0;\n  height: 0;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.sonar-wave1 {\n  animation: sonar 4s linear infinite;\n}\n\n.sonar-wave2 {\n  animation: sonar 4s linear 2.5s infinite;\n}\n\n.info-text {\n  z-index: 1;\n  font-size: calc(1.5 * var(--size-pri));\n  font-weight: 500;\n}\n\n@keyframes push-in {\n  from {\n    transform: translateY(150%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes slide-in {\n  from {\n    transform: translateX(40vw);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@keyframes sonar {\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 0.6;\n  }\n  50% {\n    width: 80vw;\n    height: 500px;\n    opacity: 0.1;\n  }\n  100% {\n    width: 80vw;\n    height: 500px;\n    opacity: 0;\n  }\n}\n\n@media (max-width: 800px) {\n  .container {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(4, auto);\n    grid-auto-flow: column;\n\n    > * {\n      grid-column: span 2;\n    }\n\n    > *:first-child {\n      margin-top: calc(2 * var(--size-pri));\n    }\n\n    > *:last-child {\n      margin-bottom: calc(2 * var(--size-pri));\n    }\n  }\n\n  .battle {\n    animation: push-in 1s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
